import Components from './../Component';

export default class FormItemCondition extends Components {
  constructor($) {
    super($);
  }

  init(index, element) {
    var attr = this.$(element).find('select, textarea, input').attr('required');
    this.$(this.$(element).attr('data-condition-element')).on('change', function (e) {
      this.test(element);
    }.bind(this));
    this.test(element);
  }

  test(element) {

    var value = this.$(element).attr('data-condition-value').split(',');
    var elementValue = this.$(this.$(element).attr('data-condition-element')).val();


    //Check if radio
    if (this.$(this.$(element).attr('data-condition-element')).attr('type') == 'radio'){
      elementValue = this.$(this.$(element).attr('data-condition-element')+':checked').val();
    }

    if (value.indexOf(elementValue) > -1) {

      if (this.$(element).attr('data-required') == 'true') {
        this.$(element).find('select, textarea, input').attr('required', 'true');
      }
      this.$(element).show();
    } else {
      this.$(element).find('select, textarea, input').removeAttr('required');
      this.$(element).hide();
    }
  }
}